import {Skeleton} from "#ui/skeleton";

export const SkeletonWrapper = ({children, visible, className, ...props}) => {
  if (visible) return <Skeleton className={className} {...props}/>;
  return children
};

